 // Get all images for desktop and mobile
 let desktopImages = document.querySelectorAll('.hero-image');
 let mobileImages = document.querySelectorAll('.hero-image--mobile');
 
 // Initialize simpleParallax for each image
 if (window.innerWidth < 749) {
   mobileImages.forEach((mobileimage) => {
     new simpleParallax(mobileimage, {
       orientation: 'up',
       delay: 0.8,
       scale: 1.5,
       overflow: true
     });
   });
 } else {
   desktopImages.forEach((image) => {
     new simpleParallax(image, {
       orientation: 'up', // Let simpleParallax handle vertical movement
       delay: 0.8,
       scale: 2,
       overflow: true
     });
   });
 }